import * as XLSX from "xlsx/xlsx.mjs";

const generateVoltzDataFile = (data) => {
  const wb = XLSX.utils.book_new();

  Object.keys(data).forEach((key) => {
    const title = key.toUpperCase();

    let item = data[key];
    if (!Array.isArray(item)) {
      item = [item].filter(Boolean);
    }
    if (item.length === 0) {
      const empty = XLSX.utils.aoa_to_sheet([]);
      XLSX.utils.book_append_sheet(wb, empty, title);
    }

    const headers = Object.keys(item[0]);
    const lines = Object.entries(item).map((value) =>
      Object.entries(value[1]).map((subValue) => subValue[1])
    );

    const ws = XLSX.utils.aoa_to_sheet([headers, ...lines]);
    XLSX.utils.book_append_sheet(wb, ws, title);
  }, {});

  XLSX.writeFile(wb, `${data.empresa?.cnpj || "data"}.xlsx`);
};

export default generateVoltzDataFile;
